import { ISPConfigMappers } from 'common/dynamic-form/services/loader/model/config-mapper.interface';
import { filterNotDefinedItems } from 'utils/filter-not-defined-items';

import { appendConfigCommonOptions } from './append-config-common-options';

import { ISPFieldConfig, ISPFormState } from '../../model';
import { TypedField } from '../form-preparing';

/**
 * Map control meta to Formly field config
 *
 * @param field - field metadata
 * @param state - dynamic form state
 * @param mappers
 */
export function getConfigsFromTypedField(
  field: TypedField,
  state: ISPFormState,
  mappers: Partial<ISPConfigMappers> = state.loaderService.fieldMappers,
): ISPFieldConfig[] {
  return filterNotDefinedItems(
    field.controls.map(control => {
      let config: ISPFieldConfig | undefined;
      const configMapperFunc = mappers[control.type];
      if (configMapperFunc) {
        config = configMapperFunc(control, field, state);
      } else {
        console.error('You should determine field mapper');
      }

      if (!config) {
        return;
      }

      appendConfigCommonOptions(
        config,
        control.control,
        field.field,
        state,
        'value' in control ? control.value : undefined,
      );

      return config;
    }),
  );
}
